import { WishType, IVote, IVoteTag } from 'types'

const voteMap = [
  { wishType: ['bus', 'bike', 'car', 'tram'], name: 'Pendeln', type: 'commute' },
  { wishType: ['bus', 'bike', 'car', 'tram'], name: 'Shoppen', type: 'shopping' },
  { wishType: ['bus', 'bike'], name: 'Sport', type: 'sport' },
  { wishType: ['bus', 'bike', 'car'], name: 'Spaß', type: 'joy' },
  { wishType: ['bus', 'bike', 'car', 'tram'], name: 'Kurze Distanzen', type: 'short-distance' },
  { wishType: ['bus', 'bike', 'car', 'tram'], name: 'Lange Distanzen', type: 'long-distance' },
  { wishType: ['bus', 'bike', 'car', 'tram'], name: 'Regelmäßig', type: 'regularly' },
  { wishType: ['bus', 'bike', 'car', 'tram'], name: 'Unregelmäßig', type: 'unregularly' },
  { wishType: ['beer'], name: 'Riegele', type: 'riegele' },
  { wishType: ['beer'], name: 'Thorbräu', type: 'thorbraeu' },
  { wishType: ['beer'], name: 'Schwarzbräu', type: 'schwarzbraeu' },
  { wishType: ['parking-lot'], name: 'Fahrrad', type: 'bike' },
  { wishType: ['parking-lot'], name: 'Roller', type: 'scooter' },
  { wishType: ['parking-lot'], name: 'Auto', type: 'car' },
  { wishType: ['parking-lot'], name: 'Park & Ride', type: 'parkandride' },
  { wishType: ['parking-lot'], name: 'Kurzzeit', type: 'time' },
  { wishType: ['parking-lot'], name: 'Langzeit', type: 'time' },
  { wishType: ['charging'], name: 'Übernacht', type: 'overnight' },
  { wishType: ['charging'], name: 'Kurzzeit', type: 'time' },
]
export const getVoteOptions = (wishType: WishType): IVoteTag[] => {
  const voteTagsForWishType = voteMap.reduce(
    (acc, voteTag) => {
      if (voteTag.wishType.some(type => type === wishType)) {
        acc.push({ ...voteTag, wishType: wishType } as any)
      }
      return acc
    },
    [] as IVoteTag[]
  )

  return voteTagsForWishType
}



// WEBPACK FOOTER //
// ./src/components/votes/votes.ts